import { render, staticRenderFns } from "./CandidatesETempLog.vue?vue&type=template&id=bc87540a&scoped=true&lang=pug"
import script from "./CandidatesETempLog.vue?vue&type=script&lang=js"
export * from "./CandidatesETempLog.vue?vue&type=script&lang=js"
import style0 from "./CandidatesETempLog.vue?vue&type=style&index=0&id=bc87540a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc87540a",
  null
  
)

export default component.exports